import React, { PropTypes } from 'react';
import { Alert, Button, Well } from 'react-bootstrap';
import './errorable.scss';

class Error extends React.Component {
  static serverSideTechnologies = ['C#'];
  static propTypes = {
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    title: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      showDetails: false
    };
  }

  message () {
    if (typeof this.props.error === 'string')
      return this.props.error;
    else if (this.props.error === undefined)
      return '';
    else
      return this.props.error.message;
  }

  serverTechnologyDetected() {
    return Error.serverSideTechnologies.includes(this.props.error.serverTechnology);
  }

  hasDetails() {
    return !!this.props.error
      && (this.serverTechnologyDetected() || this.props.error.hasOwnProperty('stack'));
  }

  details () {
    if (!this.props.error) {
      return undefined;
    }

    if (this.serverTechnologyDetected()) {
      switch (this.props.error.serverTechnology) {
        case 'C#':
          return this.props.error.exceptionType + '\n\n'
            + this.props.error.stackTrace;
      }
    } else {
      return this.props.error.stack;
    }
  }

  toggleDetails() {
    this.setState({ showDetails: !this.state.showDetails });
  }

  render() {
    let alertClass = 'error-wrapper' + (this.props.error !== undefined
      ? ' error-visible' : ''),
        detailsClass = 'error-details' + (this.state.showDetails
      ? ' error-visible' : ''),
        detailsButtonWrapperClass = 'error-details-button-wrapper' + (this.hasDetails()
      ? ' error-visible' : '');

    return (
      <Alert bsStyle="danger" className={alertClass}>
  			<b>{this.message()}</b>
  		</Alert>
    );
  }
}

export default function ({
  title = 'Se produjo un error',
  errorProp = 'error'
} = {}) {
  return Component => {
    let augmentedPropTypes = { ...Component.propTypes };
    augmentedPropTypes[errorProp] = PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]);
    return class Errorable extends Component {
      static displayName = Component.displayName || Component.name;
      static propTypes = augmentedPropTypes;
      error() {
        return this.props[errorProp]
          ? <Error error={this.props[errorProp]} title={title} />
          : undefined;
      }
    };
  };
}



// WEBPACK FOOTER //
// ./components/lib/Errorable/index.js